// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609030618/js/" + chunkId + "." + {"44":"2bf0cc47","225":"df18f664","481":"abdcbb78","486":"815346ce","770":"d609b4b4"}[chunkId] + ".0.00471336583118509.chunk.js";
};